import { render } from "./cc.vue?vue&type=template&id=839d7840"
import script from "./cc.vue?vue&type=script&lang=js"
export * from "./cc.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__